/*
 * File: /src/services/groupServices.js
 * Created Date: Friday June 14th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 14th June 2019 9:55:39 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { AD_BASE_GROUPS_PATH } from '../constants';
import { authedAxios } from '../shared/axiosWrapper';

export default {
  fetchById(id) {
    let query = AD_BASE_GROUPS_PATH;
    return authedAxios.get(query + id);
  },

  /**
   * Fetch all Groups with counts if request, may be expensive
   */
  fetchGroups(counts, brand, groupType, folderId) {
    let query = AD_BASE_GROUPS_PATH;
    const params = {
      counts: counts ? 1 : 0,
      group_type: groupType,
      folder: folderId,
    };
    if (brand) {
      params.brand_id = brand;
    }
    return authedAxios.get(AD_BASE_GROUPS_PATH, { params: params });
  },

  /*
   * Fetch a single group with counts
   */
  fetchGroupById(id, count = false) {
    let query = AD_BASE_GROUPS_PATH + id;
    if (count) {
      query = query + '?counts=1';
    }
    return authedAxios.get(query);
  },

  /**
   * Save New Group
   *
   * @param {*} groupData
   * @returns
   */
  saveNewGroup(groupData) {
    return authedAxios.post(AD_BASE_GROUPS_PATH, groupData);
  },

  /**
   * Remove Contact from Groups
   *
   * @param {*} contactId
   * @param {*} groupId
   * @returns
   */
  removeContactFromGroup(contactId, groupId) {
    return authedAxios.delete(
      AD_BASE_GROUPS_PATH + 'member/' + contactId + '/' + groupId
    );
  },

  /**
   * Delete Group
   *
   * @param {*} groupId
   * @returns
   */
  deleteGroupById(groupId) {
    return authedAxios.delete(AD_BASE_GROUPS_PATH + groupId);
  },

  /**
   * Update Group Name by ID
   * @param {number} groupId
   * @param {string} name
   */
  updateGroupNameById(groupId, name) {
    return authedAxios.put(AD_BASE_GROUPS_PATH + groupId, { name: name });
  },

  /**
   * Save Group
   *
   * @param {*} group
   * @returns
   */
  saveGroup(group) {
    if (group.id) {
      return authedAxios.put(AD_BASE_GROUPS_PATH + group.id, group);
    } else {
      return authedAxios.post(AD_BASE_GROUPS_PATH, group);
    }
  },

  /**
   * Set Default Segments
   *
   * @returns
   */
  addDefaultSegments() {
    return authedAxios.post(AD_BASE_GROUPS_PATH + 'default-segments');
  },
  // The UI sees folders as a 1 to 1 relation but they are many to one
  // so we need to be able to add a folder, remove a folder, and change
  // a folder based on context
  async setFolder(groupId, folderId, orgFolderId) {
    // If adding to a folder that is not the 'Root' folder
    if (folderId) {
      await authedAxios.put(AD_BASE_GROUPS_PATH + groupId + '/folder/' + folderId);
    }
    // If moving or removing from a folder that is not the 'root' folder
    if (orgFolderId) {
      await authedAxios.delete(AD_BASE_GROUPS_PATH + groupId + '/folder/' + orgFolderId);
    }
  }
};
